import React from 'react';
import { LocationFlag } from '@colonist/ui';
import styles from './UsernameCell.module.scss';
export const UsernameCell = ({ user, onClickLocationFlag, isUserOnDiscord })=>{
    const handleLocationFlagClick = onClickLocationFlag == undefined ? undefined : (event)=>{
        event.stopPropagation();
        onClickLocationFlag(user);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.playerCell
    }, /*#__PURE__*/ React.createElement(LocationFlag, {
        className: styles.flag,
        location: {
            countryCode: user.countryCode,
            continentCode: user.continentCode
        },
        onClick: handleLocationFlagClick,
        isUserOnDiscord: isUserOnDiscord
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.username
    }, user.username));
};
